/* One reducer for the whole billing screen. The summary, the subscriptions and
   the payments are three views of the same question - who is being billed for
   what - so they share a slice rather than being three features that have to be
   kept in step. */
const initialState = {
  loading: false,
  error: false,
  summary: null,
  subscriptions: [],
  totalSubscriptions: 0,
  payments: [],
  totalPayments: 0,
};

const billingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_BILLING_REQUEST":
      return { ...state, loading: true, error: false };

    case "GET_BILLING_FAILED":
      return { ...state, loading: false, error: true };

    case "GET_BILLING_SUMMARY_SUCCESS":
      return { ...state, loading: false, summary: action.payload };

    case "GET_BILLING_SUBSCRIPTIONS_SUCCESS":
      return {
        ...state,
        loading: false,
        subscriptions: action.payload,
        totalSubscriptions: action.total,
      };

    case "GET_BILLING_PAYMENTS_SUCCESS":
      return {
        ...state,
        loading: false,
        payments: action.payload,
        totalPayments: action.total,
      };

    default:
      return state;
  }
};

export default billingReducer;
